import { useEffect, useState } from "react";
import Card from "../../../../components/Card/Card";
import List from "../../../../components/List/List";
import Pagination from "../../../../components/Pagination/Pagination";
import { useAuth } from "../../../../contexts/auth";
import "./ListPoliticas.css";
import PolicyService from "../../../../services/PoliciesService";
import { LuShieldCheck, LuShieldOff, LuCircleCheck, LuCircleSlash2 } from "react-icons/lu";
import { TbCircleCheck } from "react-icons/tb";

const ListPoliticas = (props) => {
	const [policies, setPolicies] = useState([]);
	const [maxPage, setMaxPage] = useState(1);
	const [collumnClicked, setCollumnClicked] = useState({
		collumnTitle: "updated_at",
		orderDirection: "DESC",
	});
	const { user } = useAuth();
	const [isLoading, setIsLoading] = useState(true);

	const clientData = user.userData.selectedOrganizationId;

	const getPoliticas = async (page, searchText, clientID, orderBy) => {
		setIsLoading(true);
		try {
			const response = await PolicyService.getPaginated(
				page,
				searchText,
				clientID,
				orderBy
			);
			if (response && response.data) {
				const paginated = response.data;
				setPolicies(paginated.items);
				setMaxPage(paginated.pagination.totalPages);
			}
		} catch (error) {
			console.error(error);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getPoliticas(1, props.filters, clientData, collumnClicked);
	}, [user, props.filters, collumnClicked, clientData, props.refreshKey]);

	return (
		<>
			<div className="list-container list-visibility ">
				<List
					isLoading={isLoading}
					lineSelected={props.lineSelected}
					handleCollumnTitleClick={(col) => setCollumnClicked(col)}
					collumsObjIndex={[
						{ collumnLabel: "Nome", index: "name", type: "text" },
						{
							collumnLabel: "Efeito",
							index: "effect",
							type: "text",
							custom: ({ row }) => (
								<span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '7px' }}>
									{row.effect === 'Allow' ? (<TbCircleCheck size={18} />) : (<LuCircleSlash2 size={16} />)}
									{row.effect === 'Allow' ? 'Permitir' : 'Negar'}
								</span>
							),
						},
						{
							collumnLabel: "Condições",
							index: "conditions",
							type: "text",
							custom: ({ row }) => <span>{(row.conditions && Object.keys(row.conditions).length > 0) ? 'Sim' : 'Não'}</span>
						},
						{
							collumnLabel: "Criado em",
							index: "organizationId",
							type: "text",
							custom: ({ row }) => <span>{row.organizationId ? (user?.userData?.selectedOrganization?.id === row.organizationId ? user.userData.selectedOrganization.name : '---') : 'Global'}</span>
						},
						{ collumnLabel: "Habilitada", index: "enabled", type: "boolean" },
					]}
					data={policies?.map((policy) => ({
						...policy,
						effect: policy.effect,
					}))}
				/>
			</div>
			<div className="card-visibility">
				{policies?.map((policy, index) => (
					<Card
						key={policy.id || index}
						data={policy}
						delete={() => PolicyService.deletePolicy(policy.id)}
						navigateOnDelete={"../consulta-politicas-de-acesso"}
						navigateOnEdit={"../cadastro-politicas-de-acesso"}
					>
						<p className="card-content-title">{policy.name}</p>
						<p className="card-content">
							Efeito: {policy.effect}
						</p>
						<p className="card-content">Autoridade: {policy.authorityPath}</p>
					</Card>
				))}
			</div>
			<Pagination
				rowsPerPage={8}
				maxPage={maxPage}
				changePage={(page) =>
					getPoliticas(page, props.filters, clientData.id, collumnClicked)
				}
			/>
		</>
	);
};

export default ListPoliticas;
